import { useTranslation } from "react-i18next";
import PageHeader from "../components/PageHeader";
import { Card } from "flowbite-react";
import { useEffect, useState } from "react";
import axios from "axios";

export interface Todo {
    id: string;
    name: string;
    address: string;
    created_at: string;
}

function Home() {
    const [t] = useTranslation('common');
    const [unitCount, setUnitCount] = useState<number>(0);
    const [uncompletedChecklists, setUncompletedChecklists] = useState<[]>([]);
    useEffect(() => {
        try {
            axios.get("/units").then((response) => {
                setUnitCount(response.data.totalCount)
            });
        } catch (err) {
            console.log(err);
        }
        try {
            axios.get("/checklists/uncompleted").then((response) => {
                setUncompletedChecklists(response.data.uncompleteds)
            });
        } catch (err) {
            console.log(err);
        }
    }, []);

    const title = t("Welcome to", { app: process.env.REACT_APP_NAME });
    return (
        <div className="flex min-h-full flex-col px-4 lg:px-8 ">
            <div className="page-center">
                <PageHeader title={title} />
            </div>
            <div className="page-body mt-[103px]">
                <Card href={'/units'} className="mb-3">
                    <div className="font-normal text-gray-700 dark:text-gray-400 flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            <img className="max-w-full h-7 mx-auto" src="./assets/img/unit-icon.png" alt="Unit Icon"></img>
                            <h5 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                                Units - ({unitCount})
                            </h5>
                        </div>
                        <i className="ri-arrow-right-s-line text-2xl"></i>
                    </div>
                </Card>
                <Card href={'/checklist/uncompleted'} className={"mb-3 " + (!uncompletedChecklists?.length ? 'hidden' : '')}>
                    <div className="font-normal text-gray-700 dark:text-gray-400 flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            <i className="ri-error-warning-line text-2xl text-sared"></i>
                            <h5 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                                You have ({uncompletedChecklists?.length ?? 0}) uncompleted checklist for last week.
                            </h5>
                        </div>
                        <i className="ri-arrow-right-s-line text-2xl"></i>
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default Home;